import axios from "axios"
import router from '../router'
import qs from 'qs';
//创建axios实例 
import {
	NativeEventSource,
	EventSourcePolyfill
} from 'event-source-polyfill';
import {
	setTimeout
} from "core-js";
const md = require("markdown").markdown;
window.apiurl = (window.location.hostname == 'nestudio.neone.com.cn') ? 'https://nestudio-api.neone.com.cn' : 'https://nestudio-api.test.neone.com.cn';


const http = axios.create({
	// 设置请求地址
	// baseURL: "https://neisland-bk.test.neone.com.cn",
	baseURL: window.apiurl,
	// 设置超时时间
	timeout: 90000,
})

// import { Base64 } from 'js-base64';
// let md5 = require('js-md5');
// const access_key = 'x08HATF5hNgRGYHJ83ngAuAmFsippzxf';  // 服务端生成的 access_key
// const secret_key = 'GDNU17l6egiFryJpOSRzx0KUruTufDoO';  // 服务端生成的 secret_key

// const timestamp = Date.parse(new Date()) / 1000;    // 取时间戳

// const randomStr = (len) => {
// 	let str = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
// 	 let result = "";
// 	while(len) {
// 		let index = Math.floor(Math.random() * str.length);
// 		result += str[index];
// 		--len;

// 	}

// 	return result;

// }

// const echostr = randomStr(8);      // 随机字符串自行生成


// const header = Base64.encode(JSON.stringify({
//                    "alg": "md5",
//                    "type": "jwt"
//                }));
// const payload = Base64.encode(JSON.stringify({
//                  "timestamp": timestamp,
//                  "echostr": echostr,
//                  "ak": access_key
//              }));
// const signature_string = header  + '.' + payload;

// function md5Sign(string, secret){
//     return md5(string + secret);    // md5 库自行引入
// }

// const api_token = signature_string + '.' + md5Sign(signature_string,secret_key);

// const requestConfig = {
//     headers: {
//         "api-token": api_token
//     }
// };
//请求拦截
http.interceptors.request.use(function (config) {
	if (localStorage.getItem('usertoken')) {

		config.headers.Authorization = 'Bearer ' + localStorage.getItem('usertoken')
	}
	return config
}, function (error) {
	return Promise.reject(error)
});
//响应拦截
axios.interceptors.response.use(function (response) { // ①10010 token过期（30天） ②10011 token无效
	if (response.data.code === 10010 || response.data.code === 10011) {
		localStorage.removeItem('usertoken') // 删除已经失效或过期的token
		router.replace({
			path: '/login' // 到登录页重新获取token
		})
	} else if (response.data.token) {
		localStorage.setItem('usertoken', response.data.token) // 覆盖原来的token(默认一天刷新一次)
	}
	return response
}, function (error) {
	return Promise.reject(error)
})


http.getopenai = (title) => {
	return new Promise((s, f) => {
		http
			.post("/api/v1/openai/create", qs.stringify({
				title: title,
			}))
			.then((res) => {
				console.log(res);
				if (res.data.isSuccess == 1) {
					s(res.data.item);
				} else {

					f(res)
				}
			})
			.catch((err) => {

				console.log(err);

				f(err)
				// console.log(err);
			});
	})
}

http.createStream = (title, answer, arr, target) => {
	return new Promise((s, f) => {
		const evtSource = new EventSourcePolyfill(window.apiurl + '/api/v1/openai/create-chat-stream?title=' + title + "&continue=" + window.answer + "&model=" + "gpt-3.5-turbo", {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
			}
		});

		arr.push({
			type: 1,
			head: require("../assets/charadb/head.png"),
			content: '',
		});
		var tempStr
		evtSource.onmessage = (e) => {

			if (e.data == "[DONE]") {
				console.log('DONE')
				evtSource.close();
				s();
			} else {
				if (JSON.parse(e.data).choices[0].delta.content) {

					tempStr += JSON.parse(e.data).choices[0].delta.content;
					let tempStr_ = tempStr.replace(/undefined/g, '')
			
					window.answer = tempStr_
					// .replace(/<\/code>`/g, '')
					let str = md.toHTML(tempStr_);
					let str_=str.replace(/<\/code>`/g, "")
					// arr[arr.length - 1].content = md.toHTML(tempStr_);
				    arr[arr.length - 1].content=str_
					// console.log(arr[arr.length - 1].content)
					setTimeout(() => {
						target.scrollTo({
							top: target.scrollHeight,
							behavior: "smooth"
						});
					}, 200)
				}
			}
		};
		evtSource.onerror = (e) => {
			console.log('OnError DONE')
			// console.log(e)
			evtSource.close();
			s();
			if(arr[arr.length - 1].content==''){
				alert("请刷新此网页重试")

			}

		};

	})

}







export default http